import hostConfig from '@/common/helpers/configResolver'
import router from '@/router'
import { getNavigationHistory, storeNavigationHistory } from '@/common/services/NavigationService'
import { type RouteLocationRaw, type RouteLocationOptions } from 'vue-router'
import { sanitizeUrl } from '@/plugins/sanitizer'
import { APP_ROUTE_PATHS } from '@/app/types/router'

export default function useNavigation() {
  function redirectToLegacy(url: string) {
    window.location.href = sanitizeUrl(hostConfig.root + url)
  }

  function openCase(caseId: string | number, params?: RouteLocationOptions) {
    router.push({ path: `/assist/ticket/show/${caseId}`, ...params })
  }

  type OpenCustomerQueryOptions = {
    cti?: boolean
    caseId?: number
  }

  function openCustomer(customerId: string | number, queryOptions: OpenCustomerQueryOptions = {}, params?: RouteLocationOptions) {
    const customerRoute: RouteLocationRaw = { path: `/assist/customer/edit/${customerId}`, ...params }

    if (Object.values(queryOptions).length) {
      customerRoute.query = {
        isCti: queryOptions.cti ? 'true' : undefined,
        previousCaseId: queryOptions.caseId,
      }
    }

    router.push(customerRoute)
  }

  const goToPreviousPage = () => {
    const history = getNavigationHistory()
    if (history.length && history[history.length - 1].path !== router.currentRoute.value.path) {
      const lastPath = history[history.length - 1]
      lastPath.backNavigation = true
      storeNavigationHistory(history)
      router.push({ path: lastPath.path, force: true })
    } else {
      router.push({ path: APP_ROUTE_PATHS.HOMEPAGE, force: true })
    }
  }

  return { redirectToLegacy, openCase, openCustomer, goToPreviousPage }
}
